export function getMediaSourceType(fileNameOrUrl: string): string {
  
  const MEDIA_TYPE_MAP: Record<string, string> = {
    'mp4': 'video/mp4',

    'm3u8': 'application/x-mpegURL',
    'mpd': 'application/dash+xml',
    
    'mp3': 'audio/mpeg',
    'wav': 'audio/wav',
    'flac': 'audio/flac',
    'aac': 'audio/aac',
  };
  
  const fileName = fileNameOrUrl.includes('://') ? fileNameOrUrl.split('/').pop()?.split('?')[0]?.split('#')[0] : fileNameOrUrl;
  const extension = fileName?.split('.').pop()?.toLowerCase();

  return extension && MEDIA_TYPE_MAP[extension] || 'unknown';
}

export function extractYouTubeVideoId(url?: string): string | null {
  if (!url) return null;

  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname.toLocaleLowerCase();

    if (hostname === 'youtu.be') {
      const id = parsedUrl.pathname.slice(1);
      return id || null;
    }

    if (hostname.includes('youtube.com')) {
      const v = parsedUrl.searchParams.get('v');
      if (v) {
        return v;
      }
    }

    const pathSegments = parsedUrl.pathname.split('/');
    const embedIndex = pathSegments.indexOf('embed');
    if (embedIndex !== -1 && pathSegments.length > embedIndex + 1) {
      return pathSegments[embedIndex + 1];
    }
    const vIndex = pathSegments.indexOf('v');
    if (vIndex !== -1 && pathSegments.length > vIndex + 1) {
      return pathSegments[vIndex + 1];
    }

    return null;
  } catch (error) {
    console.error('Invalid URL:', url, error);
    return null;
  }
}